__turbopack_context__.v({
  "background": "tOFKva_background",
  "container": "tOFKva_container",
  "foreground": "tOFKva_foreground",
});
